import dayjs from "/react4xp/mixins/dayjsConfig";
import { localize } from "/react4xp/mixins/helpers";

export const columns = (translations: Record<string, string>) => [
    {
        title: localize('find-risk-degree-iin-bin', translations),
        dataIndex: 'taxpayerCode',
        key: 'taxpayerCode',
    },
    {
        title: localize('find-risk-degree-name', translations),
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: localize('find-risk-degree-degree', translations),
        dataIndex: 'degree',
        key: 'degree',
    },
    {
        title: localize('find-risk-degree-relevance-date-calc', translations),
        dataIndex: 'relevanceDate',
        key: 'relevanceDate',
        render: (date) => (date ? dayjs(date).format('DD.MM.YYYY') : '-'),
    },
    {
        title: localize('find-risk-degree-relevance-date-from', translations),
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (date) => (date ? dayjs(date).format('DD.MM.YYYY') : '-'),
    },
    {
        title: localize('find-risk-degree-relevance-date-to', translations),
        dataIndex: 'endDate',
        key: 'endDate',
        render: (date) => (date ? dayjs(date).format('DD.MM.YYYY') : '-'),
    },
];
